<template lang="pug">
  .lessons-list
    template(v-if="!loading.all && unit")
      unit-card(
        :unit="unit"
        pre-wrap
      ).mb-6

      v-subheader.mb-10
        v-btn(
          bottom
          rounded
          outlined
          text
          exact
          :to=`{
            name: 'EducationCourseUnitList',
            params: {
              courseId: course.id,
            }
          }`
        )
          v-icon mdi-chevron-left
          span Все темы
        v-divider.ml-2

      v-expansion-panels(v-model="expansionPanel" accordion flat)
        v-expansion-panel.mb-5.sdo-card.lesson(
          v-for="(lesson, idx) in unit.lessons"
          :key="lesson.id"
          :disabled="lesson.isForbidden(unit.lessons) || !course.hasPermissions.passTasks"
          outlined
          flat
        )
          tooltip-wrap(
            :text="isForbiddenText(idx)"
            :value="lesson.isForbidden(unit.lessons) || !course.hasPermissions.passTasks"
            color="error"
            max-width="600"
          )
            v-badge(
              :value="lesson.hasConsultationMessages"
              color="error"
              label="Вам что-то ответили"
              icon="mdi-message"
              overlap
              left
              bordered
            ).fill-width
              v-expansion-panel-header.py-4.rounded-lg.lesson-header
                router-link(
                  :to="lesson.getMaterialsPath()"
                ).sdo-side-element.lesson-attachments
                  .sdo-side-element--container
                    v-icon(v-if="course.hasPermissions.passTasks" dark) mdi-file
                    v-icon(v-else dark size="40") mdi-lock-outline
                    .caption.white--text.mt-2(
                      v-if="course.hasPermissions.passTasks"
                    ) Посмотреть материалы
                .sdo-side-element.lesson-progress
                  .sdo-side-element--container
                    template(v-if="!lesson.tasks.length && !lesson.user_passed")
                      .caption Без заданий
                    template(v-else-if="!lesson.user_passed")
                      tooltip-wrap(
                        text="Выполнено заданий"
                      )
                        v-progress-circular(
                          :rotate="270"
                          :size="70"
                          :width="1"
                          :value="lesson.progress"
                          :color="getStatusColor(lesson)"
                        )
                          .caption.font-weight-bold
                            div {{ lesson.tasksPassed.length }}/{{ lesson.tasks.length }}
                            div заданий
                    template(v-else)
                      tooltip-wrap(
                        text="Урок завершен"
                      )
                        v-icon(
                          size="50"
                          color="success"
                        ) mdi-check-bold
                v-list-item(
                  :disabled="lesson.isForbidden(unit.lessons) || !course.hasPermissions.passTasks"
                ).lesson-header__info
                  v-list-item-content
                    v-list-item-title
                      strong {{ idx + 1 }} урок
                      tooltip-wrap(text="Описание урока")
                        v-btn.ml-2(
                          v-if="lesson.description"
                          small icon depressed color="primary"
                          @click.stop="openLessonInfo(lesson.description)"
                        ): v-icon mdi-information-variant
                    v-list-item-title.pre-wrap {{ lesson.name }}
                    p(v-if="lesson.conferences[0]")
                      span Трансляция по уроку начнется
                      v-chip.ml-2(small color="secondary"
                      )  {{ lesson.conferences[0].date_start | dateprint_string }}
                    //- p(v-else).caption.grey--text Время проведения урока уточняется
                      //- v-chip(
                      //-   small
                      //-   v-if="lesson.conferences[0]"
                      //-   color="secondary"
                      //-   ) {{lesson.conferences[0].courseTitle}}
          v-expansion-panel-content(color="transparent")
            lesson-body(
              :lesson="lesson"
              @update="$emit('fetch-unit')"
            )

      v-expansion-panels(v-if="unit.tasks.length")
        v-expansion-panel.sdo-card(
          :disabled="!unit.isAllLessonsComplete || !course.hasPermissions.passTasks"
        )
          v-expansion-panel-header
            tooltip-wrap(
              :value="!unit.isAllLessonsComplete"
              text=`Изучите все уроки и выполните задания,
                прежде чем выполнить итоговую работу`
            )
              v-row.align-center.ma-0.pa-0
                template
                  tooltip-wrap(
                    text="Выполнено заданий"
                  )
                    v-progress-circular(
                      :rotate="270"
                      :size="70"
                      :width="1"
                      :value="unit.progress"
                      :color="getStatusColor(unit)"
                    )
                      .caption.font-weight-bold
                        div.text-center.
                          {{ unit.tasksPassed.length }}
                          /{{ unit.tasks.length }}
                        div заданий
                span.text-h6.ml-4 Тематические задания

          v-expansion-panel-content
            lesson-task(
              v-for="(task, idx) in unit.tasks"
              :key="idx"
              :task="task"
            )
      v-row(
        v-if="course.hasPermissions.passTasks"
      ).pa-0.mx-0.my-5
        v-btn(
          rounded
          :disabled="!(unit.isAllLessonsComplete && !unit.user_passed)"
          large
          depressed
          color="secondary"
          @click="unit.openChatAsStudent()"
        )
          span.mobile-hidden.mr-2 Консультация по теме
          v-badge(
            :value="unit.hasConsultationMessages"
            color="error"
            size="10"
            overlap
            dot
            bordered
          )
            v-icon mdi-forum
        v-spacer
        tooltip-wrap(
          :value="!(unit.isComplete && !unit.user_passed)"
          :text="unitPassedText(unit.user_passed)"
        )
          v-btn(
            large
            rounded
            outlined
            :disabled="!unit.isComplete || unit.user_passed"
            color="secondary"
            @click="openApproveDialog"
          )
            template(v-if="!unit.user_passed")
              span Завершить освоение темы
              v-icon(color="success").ml-2 mdi-check-all
            template(v-else)
              span Тема завершена

</template>

<script>
import {
  TASK_STATUSES,
} from '@/utils/constants';

import UnitCard from '@/modules/Education/Courses/components/UnitCard.vue';
import LessonBody from './LessonBody.vue';
import LessonTask from './LessonTask.vue';

export default {
  name: 'LessonList',
  components: {
    UnitCard,
    LessonBody,
    LessonTask,
  },
  props: {
    course: { type: Object, required: true },
    unit: { type: Object, required: true },
  },
  data() {
    return {
      TASK_STATUSES,

      loading: {
        all: false,
        lesson: false,
      },

      expansionPanel: null,
    };
  },
  provide() {
    return {
      course: this.course,
      unit: this.unit,
    };
  },
  created() {
    this.loading.all = true;
    this.checkUnreads();

    const { query, params } = this.$route;
    const lessonId = Number(params.lessonId);
    let lesson;
    if (lessonId) {
      lesson = this.unit.lessons.find((i) => i.id === lessonId);
      this.expansionPanel = this.unit.lessons.indexOf(lesson);
    }

    if (query.chat_id) {
      this.$router.replace({ query: {} });
      if (lessonId) lesson.openChatAsStudent();
      else this.unit.openChatAsStudent();
    }

    this.loading.all = false;
  },
  methods: {
    openLessonInfo(description) {
      this.$modals.show('confirm-controller', {
        title: 'Описание урока',
        message: description,
        method: () => { this.$modals.close(); },
      });
    },
    checkUnreads() {
      this.unit.lessons.forEach((i) => {
        i.fetchUnread(this.$user.data.id);
        i.fetchTranslations();
      });
      this.unit.fetchUnread({ topConsultation: true, userId: this.$user.data.id });
    },
    isForbiddenText(idx) {
      const hasTasks = idx === 0 ? false : !!this.unit.lessons[idx - 1].tasks.length;
      const prefix = 'Урок станет доступным после';
      if (!this.course.hasPermissions.passTasks) return 'Обратите, пожалуйста, внимание, доступ к курсу ограничен до поступления оплаты в сроки, предусмотренные договором.';
      return hasTasks ? `${prefix} отправки на проверку заданий предыдущего урока` : `${prefix} завершения предыдущего урока`;
    },
    getStatusColor(item) {
      let color;
      if (item.tasks.every((i) => [
        TASK_STATUSES.success,
        TASK_STATUSES.done,
      ].includes(i.status))) {
        color = 'success';
      } else {
        color = item.isFailed ? 'error' : 'warning';
      }
      return color;
    },
    openApproveDialog() {
      this.$modals.show('confirm-controller', {
        title: 'Завершение темы',
        message: 'Подтверждаете, что готовы перейти к следующей теме? Консультация будет недоступна',
        method: this.endUnit,
      });
    },
    endUnit() {
      return this.$rHandler(
        this.$api.courseUnits.passUnit(this.unit.id, {
          course_id: this.course.id,
        }),
        () => {
          this.$toasted.success('Тема успешно завершена', { duration: 2000 });
          this.$router.push({ name: 'EducationCourseUnitList', params: { id: this.$route.params.courseId } });
        },
      );
    },
    unitPassedText(isPassed) {
      return isPassed ? 'Тема завершена' : 'Завершить освоение темы Вы сможете после завершения всех уроков и успешной сдачи заданий по теме (при их наличии)';
    },
  },
};
</script>

<style lang="scss" scoped>

  .lesson {
    width: 100%;

    &.sdo-card {
      overflow: initial !important;
    }
  }

  ::v-deep {
    .lesson-header.v-expansion-panel-header--active {
      background-color: #f1f1f161;
      transition: background-color .1s ease-in-out;
      border-radius: 0px !important;

      .sdo-side-element.lesson-attachments {
        border-bottom-left-radius: 0 !important;
      }

    }
  }

  .lesson-header {

    .sdo-side-element.lesson-attachments {
      left: 0;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
      background: $secondary-color;
      transition: border-bottom-left-radius .5s;

      @media screen and (max-width: 768px){
        width: 60px;

        .caption {
          display: none;
        }
      }
    }

    .sdo-side-element.lesson-progress {
      left: 100px;

      @media screen and (max-width: 768px){
        display: none;
      }
    }

    &__info {
      margin-left: 170px;

      @media screen and (max-width: 768px){
        margin-left: 40px;
      }
    }
  }
</style>
